import React from 'react';
import { NextPage } from 'next';
import AccessibilityTemplate from '@components/Accessibility/Accessibility';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import useTranslation from '@hooks/useTranslation';
import ContentTemplate from '@ui/Content/Content';

interface IAccessibility {}

const Accessibility: NextPage<IAccessibility> = () => {
    const { t } = useTranslation();

    return (
        <>
            <HeaderTemplate />
            <ContentTemplate withPadding>
                <AccessibilityTemplate />
            </ContentTemplate>
            <FooterTemplate />
        </>
    );
};

export default Accessibility;
